export default "__VITE_ASSET__DQM0Vnav__"